import type { CustomIconProps } from '../types';

const PlayInCircle = ({ width, height, dataTestId }: CustomIconProps) => (
    <svg
        data-testid={dataTestId}
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 6C12 9.3138 9.3138 12 6 12C2.6862 12 0 9.3138 0 6C0 2.6862 2.6862 0 6 0C9.3138 0 12 2.6862 12 6ZM5.09091 3.12105C4.64143 2.8245 4 3.10662 4 3.60087V8.39913C4 8.89338 4.64143 9.1755 5.09091 8.87895L8.72727 6.47983C9.09091 6.23991 9.09091 5.76009 8.72727 5.52017L5.09091 3.12105Z"
            fill="white"
        />
    </svg>
);

export default PlayInCircle;
